import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  Typography,
  withStyles
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import commonStyles from "../commonStyles";
import ResendButton from "../ForgotPassword/ResendButton";
import AuthContainer from "../_components/AuthContainer";
import CommonPopup from "../_components/CommonPopup";
import { Event } from "../_components/Event";
import InputPaper from "../_components/InputPaper";
import config from "../_config/config";
import strings from "../_constants/strings";
import getCookie, { deleteTokens, getReferer, setTokens } from "../_helpers/cookies";
import axios from "../_helpers/interceptor";
import { goToDIY, goToLogin } from "../_helpers/navHelpers";
import { CssOutlinedInput } from "../_components/Input";

const otpSuccessEvent = new Event("OTP_SUCCESS");

function LoginWithOTP(props) {
  const {
    classes,
    // mobileNumber,
    match: {
      params: { username, step: propsStep },
    },
  } = props;
  const {
    TITLES: { OTP },
    LABELS: { USER_ID, SUBMIT, MOBILE_ID },
    ERRORS: { E_VALID_OTP },
  } = strings;

  const tabValue = getCookie('tabValue');

  const [mobileNumber, setMobileNumber] = useState(username);
  const [otpToken, setOtpToken] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [popupText, setPopupText] = useState(
    "OTP sent to registered mobile number."
  );
  const [submitting, setSubmitting] = useState(true);
  const [inputOtp, setInputOtp] = useState();
  const [otpError, setOtpError] = useState();
  const [apiError, setAPIError] = useState();
  const [expired, setExpired] = useState(false);
  const [isSignUp, setIsSignUp] = useState(false);

  useEffect(() => {
    sendOtp();
  }, []);

  const sendOtp = () => {
    var dt = {
      payload: [{ username, ogReferer: getReferer() }],
    };
    axios
      .post(`${config.endpoint}${config.loginWithOTP}`, dt)
      .then((response) => {
        console.log(response);
        const { data: { success, error } } = response;
        const { msg, otpToken, signUp } = success || error
        setOtpToken(otpToken);
        setPopupText(msg);
        setIsSignUp(signUp);
        // setIsSignUp(true);
        setIsOpen(true);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const onOTPChange = (e) => {
    e.stopPropagation();
    const {
      target: { value },
    } = e;
    setInputOtp(value);
    if (value.length != 6) {
      setOtpError(E_VALID_OTP);
    } else {
      setOtpError();
    }
  };

  const handlePopupCancel = () => {
    goToLogin(props.history);
  }

  const handlePopupOK = () => {
    if (isSignUp) {
      goToDIY(window, `mobile=${btoa(mobileNumber)}`);
      return;
    }
    if (!otpToken || expired) {
      goToLogin(props.history);
      return;
    }
    setSubmitting(false);
    setIsOpen(false);
    setIsOtpSent(true);
    otpSuccessEvent.sendMessage();
  };

  const handleOtpSubmit = () => {
    setSubmitting(true);
    let dt = {
      username,
      password: inputOtp,
      clientId: "tbsenterpriseweb",
      appId: "1",
      isOTPLogin: true,
      ogReferer: getReferer(),
      isRegisteredUser: tabValue == 1,
    };
    axios
      .post(`${config.endpoint}${config.auth}`, dt)
      .then((response) => {
        console.log(response);
        const {
          data: { success, error },
        } = response;
        if (success) {
          const { access_token, refresh_token } = success;
          deleteTokens();
          setTokens(access_token, refresh_token);
          goToDIY(window);
        }
        if (error) {
          const { error_description } = error;
          setPopupText(error_description || error.error);
          setIsOpen(true);
        }
      })
      .catch((error) => {
        console.log(error);
        deleteTokens();
        setPopupText("Invalid OTP");
        setIsOpen(true);
        setSubmitting(false);
      });
  };

  const reSendOTP = () => {
    setSubmitting(true);
    let dt = {
      payload: [{ otpToken }],
    };
    axios
      .post(`${config.endpoint}${config.resendotp}`, dt)
      .then((response) => {
        console.log(response);
        const {
          data: { success, error },
        } = response;
        if (success) {
          const { msg } = success;
          setPopupText(msg);
          setIsOpen(true);
        }
        if (error) {
          const { error_description } = error;
          setPopupText(error_description || error.error);
          setIsOpen(true);
        }
      })
      .catch((error) => {
        console.log(error);
        debugger;
        // deleteTokens();
        // setPopupText("Enter valid OTP");
        // setIsOpen(true);
        // setSubmitting(false);
      });
  };

  const onExceed = () => {
    alert("Resend attempts exceeded, kindly start over...");
    goToLogin(props.history);
  };

  return (
    <>
      <AuthContainer formtype="enter otp">
        <Box className={classes.formBox} style={{ height: "100%" }}>
          <div style={{ width: "100%" }}>
            <Typography gutterBottom className={classes.formtitle}>
              {OTP}
            </Typography>

            {/* <InputPaper
              inputtype="text"
              placeholder={USER_ID}
              disabled={true}
              value={mobileNumber}
            /> */}

            <FormControl className={classes.formControl}>
              <Typography className={classes.fieldTitle}>{MOBILE_ID}</Typography>
              <CssOutlinedInput
                id="mobileNumber"
                type={'text'}
                name="mobileNumber"
                fullWidth
                value={mobileNumber}
                variant="outlined"
                disabled
                inputProps={{
                  'aria-label': 'Mobile No',
                }}
              />
            </FormControl>

            {/* {isOtpSent && (
              <InputPaper
                autoFocus={!isOpen}
                inputtype="text"
                placeholder="Enter OTP"
                value={inputOtp}
                error={otpError ? true : false}
                handler={onOTPChange}
                errorPos="top"
                errorMsg={otpError ? otpError : null}
                disabled={submitting}
              />
            )} */}

            {isOtpSent && <FormControl className={classes.formControl}>
              <Typography className={classes.fieldTitle}>{strings?.LABELS?.OTP || ""}</Typography>
              <CssOutlinedInput
                id="otp"
                type={'text'}
                name="otp"
                fullWidth
                value={inputOtp}
                onChange={onOTPChange}
                placeholder={`Enter OTP`}
                variant="outlined"
                disabled={submitting}
                autoFocus={!isOpen}
                error={otpError ? true : false}
                inputProps={{
                  'aria-label': 'OTP',
                }}
              />
              {otpError ? <Typography variant="body2" className={classes.errorText}>{otpError || ''}</Typography> : null}
            </FormControl>}

            <div style={{ float: "right" }}>
              <ResendButton
                noAutoStart={true}
                timeOut={60}
                resendLimit={3}
                onClick={reSendOTP}
                onExceed={onExceed}
              />
            </div>
          </div>
          <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
            <Typography
              className={classes.errormsg}
              variant="caption"
              display="block"
              gutterBottom
            >
              {apiError}
            </Typography>

            <Button
              variant="contained"
              type="submit"
              className={classes.blueButton}
              onClick={handleOtpSubmit}
              disabled={submitting}
            >
              {SUBMIT}
              {submitting ? (
                <CircularProgress size="15" className={classes.spinner} />
              ) : (
                ""
              )}
            </Button>
          </div>
        </Box>
      </AuthContainer>
      {isOpen && (
        <CommonPopup
          openState={isOpen}
          popupText={popupText}
          handleClick={handlePopupOK}
          buttonText={isSignUp ? "Sign Up" : "OK"}
          cancelButtonText={isSignUp ? "OK" : null}
          handleCancel={handlePopupCancel}
        />
      )}
    </>
  );
}

export default withStyles(commonStyles)(LoginWithOTP);